/**
 * URL parameters parsed once at module-load time (before any React render).
 *
 * In Zitadel / hosted-game mode the host app appends these to the iframe URL:
 *   ?token=<jwt>&stageId=<id>&gameSessionId=<id>&key=<key>
 */
const _p = new URLSearchParams(window.location.search);

export const urlParams = {
  /** Zitadel bearer token — present in Zitadel mode. */
  token: _p.get('token') ?? '',
  /** Backend stage identifier — present in Zitadel mode. */
  stageId: _p.get('stageId') ?? '',
  /** Game session identifier — present in Zitadel mode. */
  gameSessionId: _p.get('gameSessionId') ?? '',
  /** Game key — present in Zitadel mode. */
  key: _p.get('key') ?? '',
  /** Board identifier — present in preview mode only. */
  boardId: _p.get('boardId') ?? '',
} as const;

/**
 * True when the app is launched in Zitadel / hosted-game mode.
 * Presence of `?token=` + `?stageId=` indicates Zitadel.
 */
export const isZitadelMode = !!(urlParams.token && urlParams.stageId && !urlParams.boardId);
